<template>
    <div class="payment w-100">
        <div v-if="showMainSections">
            <p class="text-danger small mb-2">* Pole obowiązkowe</p>
            <div v-if="webinar_type === 'hybrid'">
                <h4 class="mb-4 mt-3">Forma udziału <span class="text-danger">*</span></h4>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="row align-items-center text-sm-left pb-3">
                        <input
                            id="stationary-radio"
                            v-model="attendanceType"
                            :disabled="available_attendance_type === 'online'"
                            class="form-control col form-check-input-reverse col-1"
                            type="radio"
                            value="stationary"/>
                        <label
                            :class="available_attendance_type === 'online' ? 'disabled-form-label col-10 mb-0' : 'col-10 mb-0'"
                            for="stationary-radio">
                            <span
                                :style="available_attendance_type === 'online' ? 'color: #bbb; text-decoration: line-through' : ''"
                                class="mb-0 form-input-label">Udział stacjonarny</span>
                        </label>
                    </div>
                    <div class="row align-items-center text-sm-left pb-3">
                        <input
                            id="online-radio"
                            v-model="attendanceType"
                            :disabled="available_attendance_type === 'stationary'"
                            class="form-control col form-check-input-reverse col-1"
                            type="radio"
                            value="online"/>
                        <label
                            :class="available_attendance_type === 'stationary' ? 'disabled-form-label col-10 mb-0' : 'col-10 mb-0'"
                            for="online-radio">
                            <span
                                :style="available_attendance_type === 'stationary' ? 'color: #bbb; text-decoration: line-through' : ''"
                                class="mb-0 form-input-label">Udział online</span>
                        </label>
                    </div>
                    <small v-if="fieldErrors.attendanceType"
                           class="text-danger d-block mb-2">{{ fieldErrors.attendanceType }}</small>
                </div>
            </div>

            <div v-if="isLegacyMode && hotelRooms !== undefined && hotelRooms !== null && !hotelRooms.length">
                Brak dostępnych hoteli
            </div>

            <div v-if="isLegacyMode && formFields.fields">
                <div
                    v-for="(form, index) in formFields.fields.filter((form => !form.inputType || form.inputType==='checkbox'))">
                    <div
                        v-if="(!form.inputType || form.inputType === 'checkbox') && (!form.visible || form.visible === '1') && isConditionInputChecked(form.name)"
                        class="row mt-3 text-white"
                    >
                        <div class="col-lg-4 offset-lg-2 col-md-6 col-sm-12">
                            <div class="row align-items-center text-md-right text-sm-left pb-3">
                                <label
                                    :class="form.disabled === '1' ? 'disabled-form-label col-10 mb-0' : 'col-10 mb-0'"
                                    :for="form.name.split(' ').join('-').toLowerCase() + '-checkbox'">
                                    <h5 :style="form.disabled === '1' ? 'color: #bbb; text-decoration: line-through' : ''"
                                        class="mb-0"
                                        v-html="form.name"></h5>
                                </label>
                                <input
                                    :id="form.name.split(' ').join('-').toLowerCase() + '-checkbox'"
                                    :disabled="(form.disabled && form.disabled === '1') || isFieldTrue(form.name, 'with_companion')"
                                    class="form-control col form-check-input-reverse col-1"
                                    type="checkbox" @change="setPrice"
                                    @input="setFormField(form.name, 'does_attend', $event.target.checked)">
                            </div>
                            <div
                                v-if="isFieldTrue(form.name, 'does_attend') && isFieldTrue(form.name, 'companion_allowed')"
                                id="companion"
                                class="row align-items-center text-md-right text-sm-left pb-3">
                                <label class="col-10 mb-0"><h5 class="mb-0">Osoba towarzysząca</h5></label>
                                <input class="form-control col form-check-input-reverse col-1" type="checkbox"
                                       @change="setPrice"
                                       @input="setFormField(form.name, 'with_companion', $event.target.checked)">
                            </div>
                            <div v-if="isFieldTrue(form.name, 'with_companion')" class="form-row">
                                <input placeholder="Imię i nazwisko" size="col-md-6" type="text"
                                       @input="setFormField(form.name, 'companion_name', $event.target.value)">
                            </div>
                            <hr v-if="index != Object.keys(formFields.fields).length - 1" class="my-4"
                                style="background-color: white;">
                        </div>
                    </div>
                </div>

                <hr class="my-4" style="background-color: white;">
            </div>

            <div
                v-if="isLegacyMode && hotelRooms && ((formFields.fields && formFields.fields.length > 0 && isFieldTrue('Udział stacjonarny', 'does_attend')) || !isOnline)">
                <div v-for="eventDate in eventDates" class="row mt-3">
                    <div class="col-lg-4 offset-lg-2 col-md-6 col-sm-12 payment-method-section">
                        <div class="row align-items-center text-md-right text-sm-left pb-3">
                            <label class="col-10 mb-0">
                                <h4 class="mb-0" v-html="eventDate.date"></h4>
                            </label>
                            <input v-model="eventDate.checked" :value="eventDate"
                                   class="form-control col form-check-input-reverse col-1" type="checkbox"
                                   @change="setPrice">
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-lg-4 offset-lg-2 col-md-6 col-sm-12">
                        <div class="form-row">
                            <label>Nocleg <span class="text-danger">*</span></label>
                            <select v-model='hotelRoom' class='custom-select' @change="setHotelRoom">
                                <option disabled selected value="">Wybierz rekord</option>
                                <option v-for='hotelRoom in hotelRooms' :value='hotelRoom'>{{ hotelRoom.hotel_name }} -
                                    {{ hotelRoom.name }}
                                </option>
                            </select>
                            <small v-if="fieldErrors['benefit.hotel']"
                                   class="text-danger d-block mt-1">{{ fieldErrors['benefit.hotel'] }}</small>
                        </div>
                        <div v-if="hotelRoom">
                            <div v-for="(companion, index) in companions" class="form-row mt-1">
                                <input :key="index" v-model="companion.value" class="form-control"
                                       placeholder="Imię i nazwisko współlokatora" type="input">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr v-if="isEventableBenefitsMode && hasEventableBenefits" class="my-4">

            <div v-if="isEventableBenefitsMode && hasEventableBenefits">
                <h4 class="mb-4 mt-3">Dodatkowe świadczenia</h4>
                <div v-for="element in visibleEventableBenefitElements()" :key="element.code" class="row mt-3">
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <h5 v-if="element.label" class="mb-3">
                            <span v-html="element.label"></span>
                            <span v-if="isEventableElementRequired(element)" class="text-danger">*</span>
                        </h5>

                        <div v-if="element.element_type === 'checkbox'" class="pb-2">
                            <div class="d-flex align-items-center text-sm-left pb-3">
                                <input
                                    :id="`benefit-${element.code}`"
                                    :checked="isBenefitChecked(element)"
                                    :disabled="isCheckboxOptionDisabled(element)"
                                    class="form-control col form-check-input-reverse col-1"
                                    type="checkbox"
                                    @change="onBenefitCheckboxToggle(element, $event.target.checked)"
                                />
                                <label :class="checkboxLabelClass(element)"
                                       :for="`benefit-${element.code}`">
                                    {{ element.options[0]?.label }}
                                    <small v-if="Number(element.options?.[0]?.price) > 0">( +
                                        {{ Number(element.options[0].price).toFixed(2) }} zł )</small>
                                </label>
                            </div>
                            <small v-if="isLimitReached(element.options?.[0])"
                                   class="text-warning d-block mb-2">
                                Brak wolnych miejsc.
                            </small>
                            <div v-if="isBenefitChecked(element) && element.allows_companion" class="mt-2">
                                <div class="d-flex align-items-center text-sm-left pb-3">
                                    <input
                                        :id="`benefit-${element.code}-companion`"
                                        :checked="isBenefitCompanionEnabled(element)"
                                        :disabled="isCompanionDisabledByLimit(element)"
                                        class="form-control col form-check-input-reverse col-1"
                                        type="checkbox"
                                        @change="onBenefitCompanionToggle(element, $event.target.checked)"
                                    />
                                    <label :class="{
                                               'col-10 mb-0 form-input-label': true,
                                               'benefit-option-disabled': isCompanionDisabledByLimit(element),
                                           }"
                                           :for="`benefit-${element.code}-companion`">
                                        Osoba towarzysząca<br>
                                        <small v-if="Number(element.companion_price) > 0">( +
                                            {{ Number(element.companion_price).toFixed(2) }} zł )</small>
                                    </label>
                                </div>
                                <small v-if="isCompanionDisabledByLimit(element)"
                                       class="text-warning d-block mb-2">
                                    Brak wolnych miejsc.
                                </small>
                                <div v-if="isBenefitCompanionEnabled(element)" class="mt-1">
                                    <input
                                        :value="getBenefitCompanionName(element)"
                                        class="form-control"
                                        placeholder="Imię i nazwisko osoby towarzyszącej"
                                        type="text"
                                        @input="setBenefitCompanionName(element, $event.target.value)"
                                    />
                                </div>
                            </div>
                        </div>

                        <div v-else-if="element.element_type === 'radio'" class="pb-2">
                            <div v-for="option in element.options" :key="`${element.code}-${option.code}`"
                                 class="pb-3">
                                <div class="d-flex align-items-center text-sm-left">
                                    <input
                                        :id="`benefit-${element.code}-${option.code}`"
                                        :checked="getBenefitOptionCode(element) === option.code"
                                        :disabled="option.is_effectively_disabled"
                                        :name="`benefit-radio-${element.code}`"
                                        class="form-control col form-check-input-reverse col-1"
                                        type="radio"
                                        @change="setBenefitOptionCode(element, option.code)"
                                    />
                                    <label :class="optionLabelClass(option)"
                                           :for="`benefit-${element.code}-${option.code}`">
                                        {{ option.label }}
                                        <small v-if="Number(option.price) > 0">( + {{ Number(option.price).toFixed(2) }}
                                            zł
                                            )</small>
                                    </label>
                                </div>
                                <small v-if="optionUnavailabilityMessage(option)"
                                       class="text-warning d-block ml-4 pl-2 mb-0">
                                    {{ optionUnavailabilityMessage(option) }}
                                </small>
                            </div>
                        </div>

                        <div v-else class="pb-2">
                            <select :class="{'benefit-select-disabled': !hasSelectableOptions(element)}"
                                    :disabled="!hasSelectableOptions(element)"
                                    :value="getBenefitOptionCode(element)"
                                    class="custom-select"
                                    @change="setBenefitOptionCode(element, $event.target.value)">
                                <option disabled value="">Wybierz opcję</option>
                                <option v-for="option in element.options" :key="`${element.code}-${option.code}`"
                                        :disabled="option.is_effectively_disabled" :value="option.code">
                                    {{ optionDisplayLabel(option) }}
                                </option>
                            </select>
                            <small v-if="!hasSelectableOptions(element) && hasLimitReachedOption(element)"
                                   class="text-warning d-block mt-1 mb-2">
                                Brak wolnych miejsc.
                            </small>
                            <small v-else-if="selectedOptionUnavailabilityMessage(element)"
                                   class="text-warning d-block mt-1 mb-2">
                                {{ selectedOptionUnavailabilityMessage(element) }}
                            </small>
                            <div
                                v-if="element.element_type === 'hotel' && selectedHotelOption(element) && selectedHotelOption(element).requires_companion"
                                class="mt-2">
                                <div v-for="(name, idx) in getBenefitHotelCompanionNames(element)"
                                     :key="`${element.code}-companion-${idx}`" class="form-row mt-1">
                                    <input
                                        :placeholder="`Imię i nazwisko współlokatora ${idx + 1}`"
                                        :value="name"
                                        class="form-control"
                                        type="text"
                                        @input="setBenefitHotelCompanionName(element, idx, $event.target.value)"
                                    />
                                </div>
                                <small class="text-muted d-block mt-2">
                                    W przypadku niewskazania współlokatora, dobór do pokoju nastąpi automatycznie (z
                                    uwzględnieniem płci)
                                </small>
                            </div>
                        </div>
                        <small v-if="fieldErrors[`benefit.${element.code}`]"
                               class="text-danger d-block mb-2">{{ fieldErrors[`benefit.${element.code}`] }}</small>
                    </div>
                </div>
            </div>

            <hr v-if="showPaymentDetails" class="my-4">

            <div v-if="showPaymentDetails" class="payment-config-section">
                <h4 class="mb-3">Kod rabatowy</h4>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="row align-items-center text-sm-left pb-3"><input v-model.trim="code"
                                                                                 class="mb-2 form-control"
                                                                                 placeholder="Mam kod rabatowy"
                                                                                 @blur="commitCouponCode"></div>
                    <div class="row align-items-center text-sm-left pb-3">
                        <h5>Cena: <span v-html="amount"></span> zł
                            brutto</h5>
                    </div>
                    <div class="row align-items-center text-sm-left pb-3"><h5>Rabat: <span
                        v-html="discountValue"></span> zł brutto</h5></div>
                </div>
                <h4 v-if="amount > 0" class="mb-3 mt-4">Forma płatności <span class="text-danger">*</span></h4>
                <div v-if="amount > 0" class="col-lg-4 col-md-6 col-sm-12">
                    <div class="row align-items-center text-sm-left pb-3">
                        <input id="przelewy24" v-model="paymentMethod"
                               class="form-control col form-check-input-reverse col-1"
                               type="radio" value="1" @change="onPaymentMethodChange">
                        <label class="col-10 mb-0" for="przelewy24">
                            <img :src="asset_path + '/img/Przelewy24_logo.svg'" class="bg-light m-1" height="40"/>
                        </label>
                    </div>
                    <div class="row align-items-center text-sm-left pb-3">
                        <input id="przelew" v-model="paymentMethod"
                               class="form-control col form-check-input-reverse col-1"
                               type="radio" value="2" @change="onPaymentMethodChange">
                        <label class="col-10 mb-0" for="przelew">
                            <span class="form-input-label">Przelew bankowy</span>
                        </label>
                    </div>
                    <small v-if="fieldErrors.paymentMethod"
                           class="text-danger d-block mb-2">{{ fieldErrors.paymentMethod }}</small>
                </div>
            </div>
        </div>

        <hr v-if="showMainSections && amount > 0" class="my-4">

        <div v-if="showMainSections && amount > 0 && !showUserDataEditor" class="row mt-3 d-flex rounded bg-white">
            <div class="col-lg-8 col-md-10 col-sm-12 text-dark">
                <h4 class="mb-3">Sprawdź poprawność swoich danych</h4>

                <div v-if="loadingUserSummary" class="text-muted mb-3">Ładowanie danych...</div>
                <div v-else>
                    <p class="mb-1"><strong>Imię i nazwisko:</strong> {{ fullName() }}</p>
                    <p class="mb-1"><strong>Wykonywany zawód:</strong>
                        {{ getProfessionLabel(userSummary?.userProfession?.profession) }}</p>
                    <p class="mb-3"><strong>{{ professionExtraLabel() }}:</strong> {{ professionExtraValue() }}</p>

                    <h5 class="mb-2">Dane do faktury</h5>
                    <p class="mb-1"><strong>Typ:</strong> {{ userSummary?.company ? 'Firma' : 'Osoba fizyczna' }}</p>
                    <p class="mb-1"><strong>Nazwa firmy:</strong> {{ userSummary?.company?.name || '-' }}</p>
                    <p class="mb-1"><strong>NIP:</strong> {{ userSummary?.company?.nip || '-' }}</p>
                    <p class="mb-1"><strong>Ulica i numer:</strong> {{ invoiceAddress() }}</p>
                    <p class="mb-3"><strong>Kod pocztowy i miasto:</strong> {{ invoicePostalCity() }}</p>
                </div>

                <button class="btn btn-primary btn-lg" type="button" @click="showUserDataEditor = true">
                    Edytuj
                </button>
            </div>
        </div>

        <div v-if="showMainSections && amount > 0 && showUserDataEditor"
             class="row mt-3 p-4 d-flex justify-content-center rounded user-data-section bg-info">
            <user-panel
                ref="userPanel"
                :hideUpdateButton="true"
                :professions="professions"
                header="Sprawdź swoje dane"
                redirect=""
                @dirty-state-changed="onUserDataDirtyChange"
            ></user-panel>
            <div class="col-12 text-center">
                <button :disabled="savingUserData" class="btn btn-outline-light btn-lg" @click="saveUserData">
                    Zapisz dane
                </button>
            </div>
        </div>

        <hr v-if="showMainSections && amount > 0" class="my-4">

        <div v-if="showPaymentDetails" class="row justify-content-center mt-3">
            <div class="col-md-10 col-sm-12 price-section">
                <h2 class="mb-3 mt-5 text-center">Cena finalna: <span v-html="amount"></span> zł brutto</h2>
                <h6 v-if="amount > 0" class="text-center mb-4">Faktura zostanie wysłana automatycznie po otrzymaniu
                    płatności</h6>
            </div>
        </div>

        <div v-if="showMainSections && amount > 0" class="row justify-content-center my-3">
            <div class="col-sm-12 price-section">
                <h6 class="text-center my-4 h3">Przechodząc do płatności potwierdzasz poprawność swoich danych.</h6>
            </div>
        </div>

        <div v-if="showMainSections" class="row justify-content-center mt-3">
            <div class="col-sm-12 price-section">
                <div v-if="agreementInputs.length != 0">
                    <form-agreement-input v-model="agreements" :agreementInputs="agreementInputs"
                                          :error-messages="errorMessages"></form-agreement-input>
                    <hr class="my-4">
                </div>
            </div>

            <div class="price-section text-center">
                <div v-if="userDataDirty" class="alert alert-warning">
                    Zmieniłeś swoje dane. Kliknij Zapisz dane, aby móc przejść do płatności.
                </div>
                <button :disabled="isProceedButtonDisabled" class="btn btn-primary btn-lg" @click="handlePaymentForm">
                    <span v-if="amount > 0">Przejdź do płatności</span>
                    <span v-else>Zarejestruj się do wydarzenia</span>
                </button>
            </div>
        </div>

        <div v-if="content" class="bank-transfer mb-4 h3 pt-3" v-html="content"></div>
        <notifications group="foo"/>
    </div>
</template>
<script>
import FormInput from "./formInput";
import FormSelect from './formSelect';
import FormAgreementInput from "./formAgreementInput";
import UserPanel from './userPanel';

export default {
    props: ['webinar_id', 'asset_path', 'profile_url', 'is_online', 'professions', 'webinar_type', 'available_attendance_type', 'register_type'],

    components: {
        FormInput,
        FormSelect,
        FormAgreementInput,
        UserPanel,
    },
    computed: {
        isOnline() {
            return Boolean(this.is_online?.trim());
        },
        showMainSections() {
            return !this.content;
        },
        isEventableBenefitsMode() {
            return this.register_type === 'eventable_benefits';
        },
        isLegacyMode() {
            return !this.register_type || this.register_type === 'customizable_forms' || this.register_type === 'hotels';
        },
        hasEventableBenefits() {
            return !!(this.eventableBenefitsForm && this.eventableBenefitsForm.elements && this.eventableBenefitsForm.elements.length);
        },
        isProceedButtonDisabled() {
            return this.isDisabled || this.userDataDirty || this.savingUserData;
        },
        showCouponZeroedSummary() {
            return Number(this.amount) === 0 && (!!this.code || Number(this.discountValue) > 0);
        },
        showPaymentDetails() {
            if (this.amount === null) {
                return false;
            }

            return Number(this.amount) > 0 || this.showCouponZeroedSummary;
        },
    },

    data() {
        return {
            paymentMethod: null,
            amount: null,
            webinarId: this.webinar_id,
            code: null,
            discountValue: 0,
            content: null,
            agreements: [],
            hotelRooms: [],
            errorMessages: null,
            agreementInputs: [],
            formFields: [],
            customizableFormData: [],
            eventableBenefitsForm: null,
            eventableBenefitsData: {},
            isDisabled: false,
            hotelRoom: null,
            eventDates: [],
            companions: [],
            attendanceType: this.available_attendance_type === 'hybrid' ? 'stationary' : this.available_attendance_type,
            userDataDirty: false,
            savingUserData: false,
            fieldErrors: {},
            showUserDataEditor: false,
            userSummary: null,
            loadingUserSummary: false,
            priceRequestId: 0,
        }
    },
    watch: {
        attendanceType(newValue, oldValue) {
            if (oldValue !== undefined && newValue && newValue !== oldValue) {
                if (newValue === 'online' || newValue === 'stationary') {
                    this.$delete(this.fieldErrors, 'attendanceType');
                }
                if (this.isEventableBenefitsMode) {
                    this.fetchEventableBenefits();
                }
                this.setPrice();
            }
        }
    },
    beforeMount() {
        this.setPrice();
        this.fetchUserSummary();

        axios.get('/api/agreements', {
            params: {
                eventableId: this.webinarId,
                eventableType: 'App\\Models\\Webinar',
            }
        }).then(response => {
            this.agreementInputs = response.data.data;
        });

        if (this.isEventableBenefitsMode) {
            this.fetchEventableBenefits();
        } else {
            axios.get('/api/hotel-rooms', {
                params: {
                    eventableId: this.webinarId,
                    eventableType: 'App\\Models\\Webinar',
                }
            }).then(response => {
                this.hotelRooms = response.data.data;
            });

            axios.get('/api/eventables/get-dates', {
                params: {
                    eventableId: this.webinarId,
                    eventableType: 'App\\Models\\Webinar',
                }
            }).then(response => {
                this.eventDates = response.data;
            });

            axios.get('/api/customizable-forms', {
                params: {
                    eventableId: this.webinarId,
                    eventableType: 'App\\Models\\Webinar',
                }
            }).then(response => {
                this.formFields = response.data.data;
                var newFormData = [];
                if (this.formFields.fields) {
                    this.formFields.fields.forEach(function (item, index) {
                        newFormData[index] = {
                            form_name: item.name,
                            with_companion: false,
                            companion_allowed: item.companion_allowed === '1' ? true : false,
                            does_attend: false,
                            companion_name: null
                        };
                    });
                }


                this.customizableFormData = newFormData;
            });
        }
    },
    methods: {
        fetchUserSummary() {
            this.loadingUserSummary = true;
            return axios.get('/api/user-data')
                .then((response) => {
                    this.userSummary = response.data?.data || null;
                })
                .finally(() => {
                    this.loadingUserSummary = false;
                });
        },
        getProfessionLabel(professionId) {
            const map = JSON.parse(this.professions || '{}');
            return map?.[professionId] || '-';
        },
        fullName() {
            if (!this.userSummary) {
                return '-';
            }
            return [this.userSummary.name, this.userSummary.lastName].filter(Boolean).join(' ') || '-';
        },
        isStudent() {
            return Number(this.userSummary?.userProfession?.profession) === 4;
        },
        professionExtraLabel() {
            return this.isStudent() ? 'Numer legitymacji' : 'Numer prawa wykonywania zawodu';
        },
        professionExtraValue() {
            if (this.isStudent()) {
                return this.userSummary?.userProfession?.card || '-';
            }
            return this.userSummary?.userProfession?.pwz_number || '-';
        },
        invoiceAddress() {
            const address = this.userSummary?.address || {};
            const parts = [
                address.street,
                address.house_number ? ` ${address.house_number}` : '',
                address.flat_number ? `/${address.flat_number}` : '',
            ].join('');
            return parts.trim() || '-';
        },
        invoicePostalCity() {
            const address = this.userSummary?.address || {};
            const parts = [address.post_code, address.city].filter(Boolean).join(' ');
            return parts || '-';
        },
        clearFieldErrors() {
            this.fieldErrors = {};
        },
        setFieldError(field, message) {
            this.$set(this.fieldErrors, field, message);
        },
        isEventableElementRequired(element) {
            return ['radio', 'select', 'hotel'].includes(element.element_type) && this.hasSelectableOptions(element);
        },
        hasSelectableOptions(element) {
            return (element.options || []).some((option) => !option.is_effectively_disabled);
        },
        isCheckboxOptionDisabled(element) {
            return !!element.options?.[0]?.is_effectively_disabled;
        },
        isLimitReached(option) {
            return !!option?.is_limit_reached;
        },
        optionUnavailabilityMessage(option) {
            if (!option?.is_effectively_disabled) {
                return '';
            }

            return 'Brak wolnych miejsc';
        },
        optionDisplayLabel(option) {
            const priceSuffix = Number(option.price) > 0 ? ` (+ ${Number(option.price).toFixed(2)} zł)` : '';
            const unavailableSuffix = option.is_effectively_disabled
                ? ` — ${this.optionUnavailabilityMessage(option)}`
                : '';

            return `${option.label}${priceSuffix}${unavailableSuffix}`;
        },
        selectedOptionUnavailabilityMessage(element) {
            const selected = (element.options || []).find(opt => opt.code === this.getBenefitOptionCode(element));

            return this.optionUnavailabilityMessage(selected);
        },
        isCompanionDisabledByLimit(element) {
            if (!element?.allows_companion || !this.isBenefitChecked(element)) {
                return false;
            }
            const option = element.options?.[0];
            if (!option || option.is_disabled) {
                return false;
            }

            const capacity = option.max_participants_capacity;
            if (capacity === null || capacity === 0) {
                return false;
            }

            const taken = Number(option.taken_slots || 0);
            return (taken + 2) > capacity;
        },
        selectedOptionIsLimitReached(element) {
            const selected = (element.options || []).find(opt => opt.code === this.getBenefitOptionCode(element));
            return !!selected?.is_limit_reached;
        },
        hasLimitReachedOption(element) {
            return (element.options || []).some((option) => option.is_limit_reached);
        },
        checkboxLabelClass(element) {
            return {
                'col-10 mb-0 form-input-label': true,
                'benefit-option-disabled': this.isCheckboxOptionDisabled(element),
            };
        },
        optionLabelClass(option) {
            return {
                'col-10 mb-0 form-input-label': true,
                'benefit-option-disabled': option.is_effectively_disabled,
            };
        },
        fetchEventableBenefits() {
            axios.get('/api/eventable-benefits', {
                params: {
                    eventableId: this.webinarId,
                    eventableType: 'App\\Models\\Webinar',
                    attendanceType: this.attendanceType,
                }
            }).then(response => {
                this.eventableBenefitsForm = response.data.data.form;
                this.initializeEventableBenefitsState();
            });
        },
        initializeEventableBenefitsState() {
            const state = {};
            (this.eventableBenefitsForm?.elements || []).forEach((element) => {
                state[element.code] = {
                    element_code: element.code,
                    option_code: '',
                    with_companion: false,
                    companion_names: [],
                };
            });
            this.eventableBenefitsData = state;
        },
        visibleEventableBenefitElements() {
            const elements = this.eventableBenefitsForm?.elements || [];
            const selectedByElement = {};
            const visible = [];

            elements.forEach((element) => {
                const condition = element.visible_when;
                if (!this.isVisibleWhenSatisfied(condition, selectedByElement)) {
                    return;
                }

                visible.push(element);
                selectedByElement[element.code] = this.getBenefitOptionCode(element);
            });

            return visible;
        },
        extractVisibleWhenConditions(condition) {
            if (!condition || typeof condition !== 'object') {
                return [];
            }
            if (Array.isArray(condition.conditions)) {
                return condition.conditions.filter(c => c && c.element_code && c.option_code);
            }
            if (condition.element_code && condition.option_code) {
                return [{ element_code: condition.element_code, option_code: condition.option_code }];
            }
            return [];
        },
        isVisibleWhenSatisfied(condition, selectedByElement) {
            const conditions = this.extractVisibleWhenConditions(condition);
            if (!conditions.length) {
                return true;
            }
            return conditions.some(c => selectedByElement[c.element_code] === c.option_code);
        },
        getBenefitSelection(element) {
            if (!this.eventableBenefitsData[element.code]) {
                this.$set(this.eventableBenefitsData, element.code, {
                    element_code: element.code,
                    option_code: '',
                    with_companion: false,
                    companion_names: [],
                });
            }
            return this.eventableBenefitsData[element.code];
        },
        isBenefitChecked(element) {
            const selection = this.getBenefitSelection(element);
            return !!selection.option_code;
        },
        onBenefitCheckboxToggle(element, checked) {
            if (this.isCheckboxOptionDisabled(element)) {
                return;
            }
            const selection = this.getBenefitSelection(element);
            selection.option_code = checked ? (element.options?.[0]?.code || element.code) : '';
            if (!checked) {
                selection.with_companion = false;
                selection.companion_names = [];
            }
            this.setPrice();
        },
        isBenefitCompanionEnabled(element) {
            return !!this.getBenefitSelection(element).with_companion;
        },
        onBenefitCompanionToggle(element, enabled) {
            if (this.isCompanionDisabledByLimit(element)) {
                return;
            }
            const selection = this.getBenefitSelection(element);
            selection.with_companion = enabled;
            if (!enabled) {
                selection.companion_names = [];
            } else if (!selection.companion_names.length) {
                selection.companion_names = [''];
            }
            this.setPrice();
        },
        getBenefitCompanionName(element) {
            return this.getBenefitSelection(element).companion_names?.[0] || '';
        },
        setBenefitCompanionName(element, value) {
            const selection = this.getBenefitSelection(element);
            selection.companion_names = [value];
        },
        getBenefitOptionCode(element) {
            return this.getBenefitSelection(element).option_code || '';
        },
        setBenefitOptionCode(element, optionCode) {
            if (!this.hasSelectableOptions(element)) {
                return;
            }
            const selection = this.getBenefitSelection(element);
            selection.option_code = optionCode;
            this.$delete(this.fieldErrors, `benefit.${element.code}`);
            if (element.element_type === 'hotel') {
                const selected = this.selectedHotelOption(element);
                const count = selected && selected.requires_companion ? Math.max(0, Number(selected.beds_count) - 1) : 0;
                selection.companion_names = Array.from({length: count}, (_, idx) => selection.companion_names[idx] || '');
            }
            this.setPrice();
        },
        selectedHotelOption(element) {
            return (element.options || []).find(opt => opt.code === this.getBenefitOptionCode(element));
        },
        getBenefitHotelCompanionNames(element) {
            return this.getBenefitSelection(element).companion_names || [];
        },
        setBenefitHotelCompanionName(element, index, value) {
            const selection = this.getBenefitSelection(element);
            const names = [...(selection.companion_names || [])];
            names[index] = value;
            selection.companion_names = names;
        },
        buildEventableBenefitsPayload() {
            const payload = [];
            const visibleElements = this.visibleEventableBenefitElements();
            visibleElements.forEach((element) => {
                const selection = this.getBenefitSelection(element);
                if (element.element_type === 'checkbox') {
                    if (!selection.option_code) {
                        return;
                    }
                    payload.push({
                        element_code: element.code,
                        option_code: selection.option_code,
                        with_companion: !!selection.with_companion,
                        companion_names: selection.companion_names || [],
                    });
                    return;
                }
                if (!selection.option_code) {
                    return;
                }
                payload.push({
                    element_code: element.code,
                    option_code: selection.option_code,
                    companion_names: selection.companion_names || [],
                });
            });

            return payload;
        },
        validateEventableBenefitsBeforeSubmit() {
            const visibleElements = this.visibleEventableBenefitElements();
            for (const element of visibleElements) {
                if (element.element_type === 'checkbox') {
                    continue;
                }
                if (!this.hasSelectableOptions(element)) {
                    continue;
                }
                if (!this.getBenefitOptionCode(element)) {
                    this.setFieldError(`benefit.${element.code}`, 'To pole jest wymagane.');
                    this.$notify({
                        'group': 'foo',
                        'type': 'error',
                        'title': `Prosimy wybrać opcję dla pola: ${element.label || element.code}`
                    });
                    return false;
                }
            }
            return true;
        },
        setHotelRoom() {
            this.companions = [];
            this.$delete(this.fieldErrors, 'benefit.hotel');
            for (let i = 0; i < this.hotelRoom.person_limit - 1; i++) {
                this.companions.push({value: ''});
            }
            this.setPrice();
        },
        isFieldTrue(formName, inputName) {
            var existIndex = this.customizableFormData.findIndex(obj => {
                return obj.form_name === formName;
            });

            if (existIndex === -1) {
                return false;
            }

            if (this.customizableFormData[existIndex][inputName] && this.customizableFormData[existIndex][inputName] === true) {
                return true;
            }
            return false;
        },
        isFieldExist(formName) {
            console.log('check');
            var existIndex = this.customizableFormData.findIndex(obj => {
                return obj.form_name === formName;
            });

            if (existIndex === -1) {
                return false;
            }
            return true;
        },
        setFormField(formName, inputName, value) {
            var existIndex = this.customizableFormData.findIndex(obj => {
                return obj.form_name === formName;
            })

            if (existIndex === -1) {
                var newIndex = this.customizableFormData.length;
                var newArray = {
                    form_name: formName
                };
                newArray[inputName] = value;
                this.$set(this.customizableFormData, newIndex, newArray);
            } else {
                var newArray = this.customizableFormData[existIndex];
                newArray[inputName] = value;
                this.$set(this.customizableFormData, existIndex, newArray);
            }

        },
        commitCouponCode(event) {
            const normalized = (event?.target?.value ?? this.code ?? '').toString().trim();
            this.code = normalized || null;
            this.setPrice();
        },
        onPaymentMethodChange() {
            this.$delete(this.fieldErrors, 'paymentMethod');
            this.setPrice();
        },
        setPrice(forceNoCoupon = false) {
            const requestId = ++this.priceRequestId;
            const couponCode = forceNoCoupon ? null : (this.code || null);
            axios.post('/api/prices', {
                eventableId: this.webinarId,
                eventableType: 'App\\Models\\Webinar',
                customizableFormData: this.customizableFormData,
                eventableBenefitsData: this.buildEventableBenefitsPayload(),
                eventDates: this.eventDates,
                code: couponCode,
                hotelRoom: this.hotelRoom,
                attendanceType: this.attendanceType,
            }).then(response => {
                if (requestId !== this.priceRequestId) {
                    return;
                }
                this.amount = response.data.data.price;
                this.discountValue = response.data.data.discountValue;
            }).catch(error => {
                if (requestId !== this.priceRequestId) {
                    return;
                }
                this.discountValue = 0;
                const status = error?.response?.status;
                if (status === 422) {
                    const message = error.response?.data?.message
                        ? error.response.data.message
                        : error.response.data.errors?.code?.[0];

                    if (!forceNoCoupon && typeof message === 'string' && message.length > 0) {
                        this.code = null;
                        this.$notify({
                            'group': 'foo',
                            'type': 'error',
                            'title': message
                        });
                        this.$nextTick(() => {
                            this.setPrice(true);
                        });
                        return;
                    }
                    return;
                }
                if (error.response?.data?.errors || error.response?.data?.message) {
                    const message = error.response.data.message
                        ? error.response.data.message
                        : error.response.data.errors?.code?.[0];

                    this.$notify({
                        'group': 'foo',
                        'type': 'error',
                        'title': message
                    });
                }
            });
        },
        async handlePaymentForm() {
            this.isDisabled = true;
            this.clearFieldErrors();
            if (this.available_attendance_type === 'hybrid' && this.attendanceType !== 'stationary' && this.attendanceType !== 'online') {
                this.setFieldError('attendanceType', 'Wybierz formę udziału.');
                this.$notify({
                    'group': 'foo',
                    'type': 'error',
                    'title': 'Prosimy wybrać formę udziału'
                });
                this.isDisabled = false;
                return false;
            }
            if (this.available_attendance_type !== 'hybrid' && this.available_attendance_type !== this.attendanceType) {
                this.attendanceType = this.available_attendance_type;
            }
            if (this.paymentMethod === null && this.amount !== 0) {
                this.setFieldError('paymentMethod', 'Wybierz formę płatności.');
                this.$notify({
                    'group': 'foo',
                    'type': 'error',
                    'title': 'Prosimy wybrać metodę płatności'
                });
                this.isDisabled = false;
                return false;
            }
            if (this.isLegacyMode && this.formFields && this.formFields.fields && this.formFields.fields.length > 0 && this.isFieldExist('Udział stacjonarny') && this.isFieldExist('Udział online') && this.isFieldTrue('Udział stacjonarny', 'does_attend') && this.isFieldTrue('Udział online', 'does_attend')) {
                this.$notify({
                    'group': 'foo',
                    'type': 'error',
                    'title': 'Moźna wybrać tylko jeden rodzaj uczestnictwa'
                });

                this.isDisabled = false;
                return false;
            }
            if (this.isLegacyMode && this.formFields && this.formFields.fields && this.formFields.fields.length > 0 && this.isFieldExist('Udział stacjonarny') && this.isFieldExist('Udział online') && !this.isFieldTrue('Udział stacjonarny', 'does_attend') && !this.isFieldTrue('Udział online', 'does_attend')) {
                this.$notify({
                    'group': 'foo',
                    'type': 'error',
                    'title': 'Prosimy wybrać rodzaj uczestnictwa'
                });

                this.isDisabled = false;
                return false;
            }
            if (this.isLegacyMode && this.hotelRoom === null && this.hotelRooms && this.hotelRooms.length > 0 && (!this.isOnline || (this.formFields.fields.length > 0 && this.isFieldTrue('Udział stacjonarny', 'does_attend')))) {
                this.setFieldError('benefit.hotel', 'Wybierz nocleg.');
                this.$notify({
                    'group': 'foo',
                    'type': 'error',
                    'title': 'Prosimy wybrać hotel'
                });

                this.isDisabled = false;
                return false;
            }
            if (this.isEventableBenefitsMode && this.validateEventableBenefitsBeforeSubmit() === false) {
                this.isDisabled = false;
                return false;
            }
            axios.post('/api/payment/create', {
                paymentMethod: this.paymentMethod,
                code: this.code,
                eventableId: this.webinarId,
                eventableType: 'App\\Models\\Webinar',
                amount: this.amount,
                agreements: this.agreements,
                customizableFormData: this.customizableFormData,
                eventableBenefitsData: this.buildEventableBenefitsPayload(),
                hotelRoom: this.hotelRoom,
                eventDates: this.eventDates,
                companions: this.companions,
                attendanceType: this.attendanceType,
            })
                .then(response => {
                    let data = response.data.data;
                    this.errorMessages = '';
                    if (data.redirect_panel) {
                        this.$notify({
                            'group': 'foo',
                            'type': 'success',
                            'title': response.data.message
                        });

                        setTimeout(function () {
                            window.location.href = '/wydarzenie/' + data.id + '/' + data.slug;
                        }, 1500);
                    }
                    if (data.url) {
                        this.$notify({
                            'group': 'foo',
                            'type': 'success',
                            'title': response.data.message
                        });

                        setTimeout(function () {
                            window.location.href = data.url;
                        }, 1500);
                    }
                    if (data.content) {
                        this.$notify({
                            'group': 'foo',
                            'type': 'success',
                            'title': response.data.message
                        });
                        this.content = data.content;
                    }
                })
                .catch(error => {
                    this.isDisabled = false;
                    const errors = error.response?.data?.errors;
                    if (!errors) {
                        return;
                    }
                    if (errors.nip && this.$refs.userPanel) {
                        this.$refs.userPanel.errorMessages = errors;
                        this.$nextTick(() => {
                            window.scrollTo(0, document.querySelector('.error')?.offsetParent?.offsetTop || 0);
                        });
                    }
                    Object.values(errors).forEach(singleError => {
                        this.$notify({
                            'group': 'foo',
                            'type': 'error',
                            'title': singleError[0]
                        });
                    });
                });
        },
        async saveUserData() {
            if (!this.$refs.userPanel || !this.$refs.userPanel.handleUpdateForm) {
                return;
            }

            this.savingUserData = true;
            try {
                const updateResult = await this.$refs.userPanel.handleUpdateForm(true);
                if (updateResult !== false) {
                    this.userDataDirty = false;
                    this.showUserDataEditor = false;
                    await this.fetchUserSummary();
                    this.setPrice();
                }
            } finally {
                this.savingUserData = false;
            }
        },
        onUserDataDirtyChange(isDirty) {
            this.userDataDirty = isDirty;
        },
        setAgreement(e) {
            if (this.agreements.includes(e.target.value)) {
                var indexToDrop = this.agreements.indexOf(e.target.value);
                if (indexToDrop !== -1) {
                    this.agreements.splice(indexToDrop, 1);
                }
            } else {
                this.agreements.push(e.target.value);
            }
        },

        getAssetPath(path) {
            return this.asset_path + path;
        },

        setCompanionLabel(formName) {
            return this.webinarId === 341 ? formName === 'Nocleg w pok. 3-os.' ? 'Współlokatorzy' : 'Współlokator' : 'Osoba towarzysząca';
        },
        isConditionInputChecked(formName) {
            const currentIndex = this.customizableFormData.findIndex(obj => {
                return obj.form_name === formName;
            });
            // console.log('customizableFormData[' + currentIndex + '].form_name=' + this.customizableFormData[currentIndex].form_name);
            if (currentIndex === -1) {
                return true;
            }
            // Check if there is corresponding form name in form scheme
            if (!this.customizableFormData[currentIndex].form_name === this.formFields.fields[currentIndex].name) {
                // console.log('there is no corresponding form name in form scheme');
                return true;
            }
            // console.log('formFields.fields[' + currentIndex + '].name=' + this.formFields.fields[currentIndex].name);

            // Check if condition field is undefined or it has been set without condition
            if (!this.formFields.fields[currentIndex].condition || this.formFields.fields[currentIndex].condition === '0') {
                // console.log('Condition field is undefined or 0');
                return true;
            }

            // Check if there is corresponding form name to condition value
            const conditionFieldIndex = this.customizableFormData.findIndex(obj => {
                return obj.form_name === this.formFields.fields[currentIndex].condition;
            })
            if (conditionFieldIndex === -1) {
                // console.log('there is no corresponding form name for that condition name');
                return true;
            }
            // console.log('customizableFormData[' + conditionFieldIndex + '].form_name=' + this.customizableFormData[conditionFieldIndex].form_name);

            // Check if corresponding form name has been checked
            return this.customizableFormData[conditionFieldIndex].does_attend;
        },
    }
}
</script>

<style lang="scss">
.form-input-label {
    font-weight: 500;
    font-size: 1.15em;
}

.benefit-option-disabled {
    color: #bbb;
    text-decoration: line-through;
    cursor: not-allowed;
}

.benefit-select-disabled {
    color: #bbb;
    text-decoration: line-through;
    background-color: #e9ecef;
    cursor: not-allowed;
}

.custom-select option:disabled {
    color: #999;
    font-style: italic;
}

</style>
